import {defineStreamComponentRegistration} from '@Components/ai-chat-window/lib/stream-component-registration';
import {isOptionalString, isPlainObject} from '@Components/ai-chat-window/lib/stream-component-prop-guards';
import type {ButtonAction, ButtonGroupProps, ButtonSpec} from './button-group.types';
import {BUTTON_GROUP_COMPONENT_TYPE} from './button-group.types';
import {ButtonGroup} from './button-group';

const isButtonAction = (value: unknown): value is ButtonAction => {
  if (!isPlainObject(value) || value.type !== 'download') {
    return false;
  }

  return typeof value.chatId === 'string' && typeof value.hashedId === 'string' && typeof value.fileType === 'string' && typeof value.imageQuality === 'string';
};

const isButtonStyle = (value: unknown): boolean => {
  return value === undefined || value === 'primary' || value === 'secondary';
};

const isButtonSpec = (value: unknown): value is ButtonSpec => {
  return isPlainObject(value) && typeof value.label === 'string' && isButtonAction(value.action) && isOptionalString(value.icon) && isButtonStyle(value.style);
};

export const buttonGroupRegistration = defineStreamComponentRegistration(
  BUTTON_GROUP_COMPONENT_TYPE,
  ButtonGroup,
  (props: Record<string, unknown>): ButtonGroupProps | null => {
    if (!Array.isArray(props.buttons) || !props.buttons.every(isButtonSpec)) {
      return null;
    }

    return {buttons: props.buttons};
  }
);
